/* eslint-disable react-hooks/exhaustive-deps */
import { Form } from 'antd'
import React, { useEffect } from 'react'
import { useTranslation } from 'next-i18next'
import { RegisterCompleteStepChanger } from '../index'
import { useAppDispatch, useAppSelector } from 'src/app/hooks'
import { CustomCard, CustomTitle, CustomText } from 'src/components'
import { getCompleteInfoFormSections } from './complete-register.sections'
import { completeInfoStateSelector, setCompleteRegisterFormValue } from 'src/features'

interface FormPayload { reasonToRegister: string, companyPosition: string }

const CompleteRegisterInfoForm: React.FC = () => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const [form] = Form.useForm()
  const sections = getCompleteInfoFormSections(t)
  const completedData = useAppSelector(completeInfoStateSelector)

  const onFinish = (values: FormPayload) => {
    dispatch(setCompleteRegisterFormValue({ key: 'reasonToRegister', value: values.reasonToRegister }))
    dispatch(setCompleteRegisterFormValue({ key: 'companyPosition', value: values.companyPosition }))
    dispatch(setCompleteRegisterFormValue({ key: 'step', value: 3 }))
  }

  useEffect(() => {
    form.setFieldsValue({
      ['reasonToRegister']: completedData.reasonToRegister,
      ['companyPosition']: completedData.companyPosition,
    })
  }, [completedData])

  return (
    <Form
      onFinish={onFinish}
      form={form}
    >
      <CustomCard>
        <CustomTitle label={t('Auth.CompleteInfo.Title2')} type={null} />
        <CustomTitle label={t('Auth.CompleteInfo.Subtitle2')} />

        {sections.map((section, idx) => <div key={idx}>
          <CustomTitle className='label-input' {...section.labelProps} />
          <CustomText label={section.childLabel} type='secondary' />
          <section.formComponent {...section.formProps} />
        </div>)}
      </CustomCard>

      <RegisterCompleteStepChanger
        nextStepValue={null}
        beforeStepValue={1}
      />
    </Form>
  )
}

export default CompleteRegisterInfoForm
